// extracted by mini-css-extract-plugin
export default {"StepTwo":"StepTwo_StepTwo__TnKRy","InputWrapper":"StepTwo_InputWrapper__oXwWg","LabelText":"StepTwo_LabelText__GvsqV","Footer":"StepTwo_Footer__CMcX9"};